/**
 * The browser's local civil date (YYYY-MM-DD) — the user's "today". Day-granular
 * windows (overdue / upcoming, a passed RSVP deadline) must key off the user's
 * calendar day, not the server's UTC day, so we pass it to endpoints that
 * compute those counts (as `?today=`, read by the API's resolveTodayAnchor).
 * Uses local getters (not toISOString, which is UTC) so it's the user's civil date.
 */
export function clientToday(): string {
  const d = new Date();
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/**
 * The browser's IANA time zone ("Europe/Athens"), or "" when it has none. Sent
 * with `today` where the API turns a stored instant into the user's calendar
 * day (Éros dating a sent invitation); the API checks it and falls back to UTC.
 */
export function clientTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    return '';
  }
}
